export default __webpack_public_path__ + "static/media/logo-desktop.865c03db.svg";